module.exports = __webpack_public_path__ + "img/OK.c99e48f1.png";